import TrailerAlertOverlay from '@/app/[locale]/[roomId]/components/TrailerAlertOverlay'
import TrailerCarouselEmptyState from '@/app/[locale]/[roomId]/components/TrailerCarouselEmptyState'
import TrailerCarouselSlide from '@/app/[locale]/[roomId]/components/TrailerCarouselSlide'
import Loader from '@/components/Loader'
import { useTrailerViewMediaContext } from '@/context/TrailerViewMediaContext'
import { useEnableFull3d } from '@/hooks/useEnableFull3d'
import { cn } from '@/lib/utils'
import { useState } from 'react'

const TrailerCarousel = () => {
  const {
    mediaList,
    currentIndex,
    setCurrentIndex,
    currentMedia,
    handleVideoEnded,
    isLoading,
    isEmpty,
    playKey,
  } = useTrailerViewMediaContext()
  const enableFull3d = useEnableFull3d()
  const [closeAlert, setCloseAlert] = useState(false)
  return (
    <div
      className={cn(
        'pointer-events-auto relative aspect-[16/9] h-full w-full overflow-hidden',
        (isLoading || isEmpty) && 'bg-gradient-to-b from-[#1c3356] to-[#131b26]',
        { 'rounded-[15px]': !enableFull3d },
      )}
    >
      {!closeAlert && <TrailerAlertOverlay setCloseAlert={setCloseAlert} />}
      {isLoading ? (
        <Loader className="absolute top-1/2 left-1/2 h-6 w-6 -translate-x-1/2 -translate-y-1/2 transform" />
      ) : isEmpty ? (
        <TrailerCarouselEmptyState />
      ) : (
        <TrailerCarouselSlide
          media={currentMedia}
          onEnded={handleVideoEnded}
          mediaList={mediaList}
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
          playKey={playKey}
        />
      )}
    </div>
  )
}

export default TrailerCarousel
